






















































































import {mapActions, mapGetters} from 'vuex';
import ProfilePicture from '@/components/profile/ProfilePicture.vue';
import {AdvertTypeItems, AdvertTypes} from '@/store/modules/Advert/state';
import Vue from 'vue';
import {AdvertConversation} from '#/Advert';
import {AdminMessage, LastMessage, LastMessageConversation} from '#/Conversations';

interface ComponentData {
  conversationsLoaded: boolean;
  localAdvertsConversation: AdvertConversation[];
  panelOpened: number | undefined;
  panels: {
    [conversationId: number]: {
      alreadyOpened?: boolean;
      conversations?: LastMessageConversation[];
    };
  };
}

export default Vue.extend({
  name: 'MessageList',

  components: {
    ProfilePicture,
  },

  data: (): ComponentData => ({
    conversationsLoaded: false,
    localAdvertsConversation: [],
    panelOpened: undefined,
    panels: {},
  }),

  computed: {
    ...mapGetters([
      'advertsConversation',
      'conversations',
      'hasNewPrivateMessage',
      'privateMessages',
      'profile',
    ]),
    adminHasNewPrivateMessage(): boolean {
      return this.hasNewPrivateMessage || this.privateMessages.some((message: AdminMessage) => {
        if (typeof message.type === 'number') return false; // message de type admin-message

        return message.readAt === null;
      });
    },
    getAdvertConversation(): undefined | LastMessageConversation[] {
      if (this.panelOpened) {
        return this.panels[this.panelOpened]?.conversations;
      }

      return undefined;
    },
    hasAdminMessage(): boolean {
      return !!this.privateMessages.length
    },
    privateMessageTitle(): string {
      return this.privateMessages[0]?.title || '';
    },
  },

  created() {
    Promise.all([
      this.loadAdvertsConversation(),
      this.loadNewAdminMessages({}),
      this.loadPrivateAdminMessages(),
    ])
           .then(() => {
             this.advertsConversation.forEach((conversation: AdvertConversation) => {
               this.localAdvertsConversation.push({...conversation});

               this.panels[conversation.id] = {
                 alreadyOpened: false,
                 conversations: [],
               };
             });
             this.updatePageTitle(this.$t('messages.title'));
           });
  },

  methods: {
    ...mapActions([
      'updatePageTitle',
      'updateProfile',
      'loadConversations',
      'loadAdvertsConversation',
      'loadNewAdminMessages',
      'loadPrivateAdminMessages',
    ]),
    getColor(typeId: AdvertTypes): string {
      return AdvertTypeItems[typeId].color;
    },
    onOpenPanel(panelOpened: number | undefined): void {
      if (panelOpened !== undefined) {
        this.conversationsLoaded = false;

        if (this.hasAdminMessage && panelOpened === 0) return;

        const {id} = this.localAdvertsConversation[this.hasAdminMessage ? panelOpened - 1 : panelOpened];
        const panel = this.panels[id];

        if (!panel.alreadyOpened) {
          this.loadConversations(id)
              .then(() => {
                (this.conversations[id] as LastMessageConversation[]).forEach(conversation => {
                  if (panel.conversations) {
                    panel.conversations.push({...conversation});
                  }
                });

                this.panelOpened = id;
                this.conversationsLoaded = true;
              });

          panel.alreadyOpened = true;
        } else {
          this.conversationsLoaded = true;
          this.panelOpened = id;
        }
      } else {
        this.panelOpened = undefined;
      }
    },
    truncatedLastMessage(lastMessage: LastMessage): string {
      const {content, author} = lastMessage;
      const maxLength = 30;

      const prefix = this.profile.id === author ? 'Vous : ' : '';
      let displayContent = content;
      if (content.length > maxLength) {
        displayContent = content.slice(maxLength, 1) === ' '
            ? content.slice(0, maxLength) + '...'
            : content.slice(0, content.slice(0, maxLength)
                                      .lastIndexOf(' ')) + '...';
      }
      return `${prefix}"${displayContent}"`;
    },
  },
});
